import { HighlightSkeletonCard } from '@components/highlight-skeleton-card';
import { getHighlightColumnSpans } from '@utils/event-report/get-highlight-column-spans';
import { getHighlightColumnSpansBesideCard } from '@utils/event-report/get-highlight-column-spans-beside-card';

import { HighlightSectionSkeletonCardsProps } from './highlight-section-skeleton-cards.type';

export const HighlightSectionSkeletonCards = ({
  cardCount = 6,
  isBesideLeadingCard = false,
}: HighlightSectionSkeletonCardsProps) =>
  Array.from(
    (isBesideLeadingCard ? getHighlightColumnSpansBesideCard : getHighlightColumnSpans)(cardCount),
    (columnSpan, i) => (
      <HighlightSkeletonCard
        key={`highlight-card-${i}`}
        dataTestId={`highlight-card-skeleton--${i}`}
        columnSpan={columnSpan}
      />
    )
  );
